import * as React from 'react';

import Popper from 'ha/ui/next/Popper';
import Track from 'ha/components/track/SmartTrack';

import SearchMapPreview from '../SearchMapPreview';
import Pin from './Pin';
import { MapProps, RoomMarker as RoomMarkerType } from './Types';
import { RoomMarkerSize, PartnerMarkerSize } from './constants';

const { height, pointX, pointY } = PartnerMarkerSize;

const containerStyle: React.CSSProperties = {
  position: 'relative',
  height,
  left: -pointX,
  top: -pointY,
};

const padding = {
  top: 70,
  bottom: 70,
  left: 16,
  right: 16,
};

interface Props {
  marker: RoomMarkerType;
  highlightedRoomId: number;
  lat: number;
  lng: number;
  boundariesElement: HTMLDivElement | null;
}

const RoomMarker: React.SFC<Props & Partial<MapProps>> = ({
  marker,
  highlightedRoomId,
  $hover: hovered,
  boundariesElement,
}) => {
  const highlightedInList = marker.rooms.some(
    room => room.id === highlightedRoomId,
  );

  const modifiers = {
    preventOverflow: {
      enabled: true,
      boundariesElement,
      padding,
    },
  };

  const anchor = (
    <Track name="Clicked on a pin with price in map" type="button">
      <Pin
        marker={marker}
        markerSize={RoomMarkerSize}
        emphasis={hovered || highlightedInList}
        highlightedRoomId={highlightedRoomId}
      />
    </Track>
  );

  return (
    <div style={containerStyle}>
      <Popper anchor={anchor} modifiers={modifiers}>
        {({ handleClose }) => (
          <SearchMapPreview rooms={marker.rooms} onClose={handleClose} />
        )}
      </Popper>
    </div>
  );
};

export default RoomMarker;
